import React, { useEffect, useState } from 'react'
import { Tooltip } from 'src/component/Tooltip';
import { useOrderStore } from 'src/hooks/order';
import useReduxState from 'src/hooks/useReduxState';
import infoIcon from 'src/assets/images/info.svg'
import System from 'src/helper/system';
import AxiosIndicatorRunTimeLoader from 'src/component/AxiosIndicatorRunTimeLoader';
import { useFilterSelectionStore } from 'src/hooks/component/filter_selection';
import Constants from 'src/support/Constants';
import SystemAlerts from 'src/component/SystemAlerts';
import Helper from 'src/support/Helper';
import keylegendIcon from 'src/assets/images/key.svg'


const OrderHistoryHeader = (props) => {
    const [{ order_list, order_export_count }, { }, { export_order }] = useOrderStore();
    const [isExportFilter, setIsExportFilter] = useReduxState(false, 'setIsExportFilter');
    const [pageLoader, setPageLoader] = useState(false);
    const [{ filter_list }, { }, { }] = useFilterSelectionStore();
    const [disable, setDisable] = useState({ emailFiltered: false });

    useEffect(() => {
        sessionStorage.removeItem("successUrl")
    }, []);

    useEffect(() => {
        const isOrderListEmpty = order_list && order_list.total === 0;
        if (isOrderListEmpty) {
            if (order_export_count > 0) {
                setDisable({ emailFiltered: true, emailAll: false })
            } else {
                setDisable({ emailFiltered: true, emailAll: true })
            }
        }
        else if (!isOrderListEmpty) {
            setDisable({ emailFiltered: false, emailAll: false })
        }
    }, [order_list, filter_list, order_export_count]);

    const exportAllOrder = async () => {
        closeDropdown();
        setPageLoader(true);
        setTimeout(() => {
            setPageLoader(false);
            System.popup('ThankYouPopup', { isOrderHistory: true }); // open pop-up before API Call    
        }, 2000);
        let result = await export_order({
            "keyword": "",
            "searchType": "",
            "filterByOption": [],
            "timeSpan": "",
            "sortBy": "",
            "sortOrder": "",
            "isExportAll": true,
            "isEmail": true
        });
    }

    const exportFilterOrder = async () => {
        closeDropdown();
        setPageLoader(true);
        await setIsExportFilter(true)

        setTimeout(() => {
            setPageLoader(false);
        }, 2000);
    }
    /**
     * Ticket #  : 9806
     * Change #  : Information Tooltip change
     * Change by : Pankaj
     * Date      : 20 March 2023
     */
    const renderInformationTooltip = () => {
        return (
            <>
                Additional order information available by choosing to receive an email on your orders.
            </>
        )
    }
    const closeDropdown = () => {
        let _dropdownElem = document.getElementById('emailFilter');
        if (_dropdownElem !== undefined && _dropdownElem.classList.contains('open')) {
            _dropdownElem.removeAttribute('class');
            _dropdownElem.setAttribute('class', 'dropdown ms-4')
        }
    }

    const renderKeyLegendTooltip = () => {
        return (
            <>
                <b>Offline:</b> Orders created in the {System.avUserInfoData.speedBoatName} <br />
                Internal Order Tool <br />
                <b>Online:</b> Orders created in {Helper.getHCLDXBaseUrlHost()}
            </>
        )
    }

    return (
        <>
            <div className="pcn-page-head header-container d-flex align-items-center justify-sm-content-between flex-wrap flex-sm-nowrap">
                <div className="page-title font-oswald font-light font-30 mb-3 mb-sm-0">Order Details</div>
                <div className="ms-sm-auto mb-0">
                    <ul className="d-flex justify-content-start justify-content-lg-end list-unstyled mb-0 order-history-top">
                        <li className='ms-4'>
                            <Tooltip
                                position={'bottom left'}
                                opener={() => (
                                    <a className="customer-link cursor-default" href={void (0)}><i><img className="" src={keylegendIcon} alt='Key/Legend' /></i><span
                                        className="bs5 text-blue">Key/Legend</span></a>
                                )}
                                content={() => (
                                    renderKeyLegendTooltip()
                                )}
                            />
                        </li>
                        <span className='order-history-header'>
                            <div className="ms-4">
                                {pageLoader && <AxiosIndicatorRunTimeLoader />}
                            </div>
                            {pageLoader === false &&
                                <li id="emailFilter" className="dropdown ms-4">
                                    <a href={void (0)} data-toggle="dropdown" aria-expanded="false"><i className="fa fa-envelope me-2 text-black" aria-hidden="true"></i> Email Orders</a>
                                    <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                                        <li><a className={disable.emailAll ? "dropdown-item link-disabled" : "dropdown-item"} href={void (0)}
                                            onClick={() => exportAllOrder()}>Email All</a></li>
                                        <li><a className={disable.emailFiltered ? "dropdown-item link-disabled" : "dropdown-item"} href={void (0)}
                                            onClick={() => exportFilterOrder()}>Email Filtered</a></li>
                                    </ul>
                                </li>
                            }
                        </span>

                        <li className="ms-4">
                            <Tooltip
                                position={'bottom right'}
                                opener={() => (
                                    <a className={pageLoader ? "customer-link link-disabled cursor-default" : "customer-link cursor-default"} href={void (0)}><i><img className="" src={infoIcon} alt='Information' /></i><span
                                        className="bs5 text-blue">Information</span></a>
                                )}
                                content={() => (
                                    renderInformationTooltip()
                                )}
                            />
                        </li>
                    </ul>
                </div>
            </div>
            <div className="pcn-line-divider mb-0" />
            <SystemAlerts />
        </>
    )
}

export default OrderHistoryHeader